import { get } from './apiService';

/**
 * BE response for GET /r/{ref} — a campaign short link. targetUrl is the
 * campaign's landing URL as of now: its target plus the UTM tuple for the
 * link's variant and language (or the campaign's archive redirect).
 */
export interface CampaignLinkTarget {
  targetUrl: string;
}

export async function resolveCampaignLink(ref: string): Promise<CampaignLinkTarget> {
  return get<CampaignLinkTarget>(`/r/${encodeURIComponent(ref)}`);
}
